export enum BlockType {
  DYNAMIC = "DYNAMIC",
  DEMOGRAPHICS = "DEMOGRAPHICS",
  INSURANCE = "INSURANCE",
  MEDICAL_HISTORY = "MEDICAL_HISTORY",
  PAYMENT_METHODS = "PAYMENT_METHODS",
  FITZPATRICK = "FITZPATRICK",
}

/**
 * Block types whose answers are addressed by mapping key rather than question id.
 *
 * These four render through dedicated components and submit through typed pydantic
 * schemas whose fields are named after the mapping (`SubmittedDemographicsBlock`,
 * `SubmittedMedicalHistoryBlock` and friends), so their field names must stay the
 * mapping. Everything else falls through to `DynamicBlock` and is keyed by question
 * id, which lets a form hold more than one question on the same mapping.
 *
 * A consequence worth knowing: because the backend resolves a mapping-named field
 * through a form-wide alias, a mapping owned by one of these blocks cannot safely be
 * bound by a second question elsewhere in the same form — the alias would send both
 * answers to whichever question comes last.
 */
export const MAPPING_KEYED_BLOCK_TYPES: ReadonlySet<BlockType> = new Set([
  BlockType.DEMOGRAPHICS,
  BlockType.INSURANCE,
  BlockType.MEDICAL_HISTORY,
  BlockType.PAYMENT_METHODS,
]);
